<template>
  <div class="main-page-view">
    <!--顶部的Tab组件-->
    <TopView :topList="topList"
             @switchTabIndex="switchTabIndex"></TopView>
    <!--视频列表和我的视频-->
    <VideoList v-if="currentTabIndex === 1"
               ref="videoList">
    </VideoList>
    <!--视频列表和我的视频-->
    <VideoByMeList v-if="currentTabIndex === 2"
               ref="videoByMeList"
               @resetCurrentPage="resetCurrentPage">
    </VideoByMeList>
    <!--我的消息-->
    <TransmitList v-if="currentTabIndex === 3"
               ref="transmitList"
               @resetCurrentPage="resetCurrentPage">
    </TransmitList>
  </div>
</template>
<script>
import TopView from './TopView'
import VideoList from './VideoList'
import VideoByMeList from './VideoByMeList'
import TransmitList from './TransmitList'
import MixinWx from "@/mixin/authUser";
export default {
  components: {
    TopView:TopView,
    VideoList:VideoList,
    VideoByMeList:VideoByMeList,
    TransmitList:TransmitList,
  },
  name: "PlatformMainPage",
  mixins: [MixinWx],
  data() {
    return {
      //当前展示组件
      currentTabIndex:1,
      topList:[
        {
          tabIndex: 1,
          tabText:'视频推荐',
          tabViewActive:'tab-view',
        },
        {
          tabIndex: 2,
          tabText:'我的视频',
          tabViewActive:'tab-view',
        },
        {
          tabIndex: 3,
          tabText:'我的消息',
          tabViewActive:'tab-view',
        }
      ]
    };
  },
  methods: {
    //刷新当前界面
    resetCurrentPage(){
      console.log('resetCurrentPage:刷新当前界面')
      this.switchTabIndex(this.currentTabIndex)
    },
    //切换Tab
    switchTabIndex(index){
      console.log('switchTabIndex:'+index)
      if(!index){
        return;
      }
      this.currentTabIndex = index;
      if(index === 1){
        if(this.$refs.videoList){
          this.$refs.videoList.queryVideoList({
            querySelf:false
          });
        }
      }
      if(index === 2){
        if(this.$refs.videoByMeList){
          this.$refs.videoByMeList.queryVideoList({
            querySelf:true
          });
        }
      }
      if(index === 3){
        if(this.$refs.transmitList){
          this.$refs.transmitList.queryCurrentTransmit();
        }
      }
    }
  },
  created() {
    //this.init();
  },
  destroyed() {

  },
};
</script>


<style lang="scss" scoped>
.main-page-view {
  //height: 100Vh;
  //position: relative;
  //border: 2px solid #ef1313;
  .search-view{
    width: 100%;
    margin: 10px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .search-item-view{
      margin: 10px 10px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      width: 70%;
      .search-title{
        margin: 10px 5px;
        font-size: 20px;
        font-weight: bold;
      }
      .search-item{
        width: 60%;
        margin: 10px 5px;
        border-radius: 3px;
      }
      .search-button{
        margin: 10px 5px;
      }
    }
  }
  .sketch-view{
    width: 100%;
    margin: 10px 10px;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    .sketch-item-view{
      margin: 10px 10px;
      .sketch-item{

      }
    }
  }
  .pagination-view{
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position:fixed;
    bottom:0;
    background-color: #edeff1;
    .pagination-item-view{
      //background-color: #edeff1;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PlatformMainPage.vue?34814b68